import { useState } from 'react';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { paymentMethodCodes } from '../../../constants/paymentMethods';
import { getMethod } from '../../../utils/paymentMethods';
import { initSession } from '../utils/session';
import type { TransformedPaymentMethod } from '../../../models';

export const usePayPal = (paymentMethods: TransformedPaymentMethod[]) => {
  const [payPalSessionData, setPayPalSessionData] = useState<string | null>(null);

  const hasPaypalPaymentMethod = Boolean(
    getMethod(paymentMethods, paymentMethodCodes.PAYPAL) ??
      getMethod(paymentMethods, paymentMethodCodes.PAYPAL_PAY_LATER),
  );

  useDeepCompareEffect(() => {
    const initPayPal = async () => {
      const sessionData = await initSession();
      setPayPalSessionData(sessionData.token ?? '');
    };
    if (hasPaypalPaymentMethod) {
      initPayPal();
    }
  }, [paymentMethods, hasPaypalPaymentMethod]);

  try {
    const payPalClientId: string | null = payPalSessionData
      ? JSON.parse(window.atob(payPalSessionData))?.paypal?.clientId ?? null
      : null;

    return { payPalSessionData, payPalClientId, hasPaypalPaymentMethod };
  } catch {
    return { payPalSessionData, payPalClientId: null, hasPaypalPaymentMethod: false };
  }
};
